import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, DataTable, FlexBox, HelpIcon, IconButton, Switch, Text, Tooltip, } from '@dixa/lib-shared-habla';
import { useNavigate } from 'react-router-dom';
export const Languages = ({ defaultLanguageCode, languages, onLanguageStatusChange, }) => {
    const navigate = useNavigate();
    return (_jsx(DataTable, { data: languages, columns: [
            {
                label: 'Language',
                selector: (language) => {
                    const isDefault = language.code === defaultLanguageCode;
                    if (isDefault) {
                        return (_jsxs(FlexBox, Object.assign({ gap: "250", alignItems: "center" }, { children: [_jsx(Text.Paragraph, Object.assign({ as: "span" }, { children: language.name })), _jsx(Badge, Object.assign({ variant: "primary", size: "small" }, { children: "Default" })), _jsx(HelpIcon, { text: "CSAT ratings have English enabled by default and you can edit the English text, but it cannot be disabled.", dark: true })] })));
                    }
                    return (_jsx(Text.Paragraph, Object.assign({ color: language.isSetup ? 'primary' : 'tertiary' }, { children: language.name })));
                },
            },
            {
                label: 'Enabled',
                selector: (language) => {
                    const isDefault = language.code === defaultLanguageCode;
                    if (language.isSetup && !isDefault) {
                        return (_jsx(Switch, { name: language.code, value: language.code, checked: language.enabled, onChange: () => onLanguageStatusChange({
                                language,
                                newStatus: !language.enabled,
                            }) }));
                    }
                },
                style: {
                    width: 0,
                },
            },
            {
                label: '',
                selector: (language) => {
                    return (_jsx(Tooltip, Object.assign({ content: language.isSetup ? 'Edit' : 'Setup', dark: true }, { children: _jsx(IconButton, { icon: language.isSetup ? 'pen' : 'cog', variant: "tertiary", onClick: () => navigate(`/settings/satisfaction/chat/${language.code}`) }) })));
                },
                style: {
                    width: 0,
                },
            },
        ], tableStyleProps: {
            stickyHeader: true,
        } }));
};
